export var CASES_LIST_EDIT_FILTER = 'cases-list-edit-filter';
export var CASES_LIST_DEFAULT_FILTER = 'cases-list-default-filter';
export var CASES_LIST_UPDATE_COLUMNS = 'cases-list-update-columns';
export var CASES_LIST_REFRESH = 'cases-list-refresh';
export var CASES_LIST_EXPORT = 'cases-list-export';
